import { withRouter } from 'react-router-dom';
import { compose, mapProps } from 'recompose';
// import get from 'lodash/get';
// import set from 'lodash/set';

// import { DATA_CENTER_FLOW_POSTFIX_URL, DATA_CENTER_FLOW_POSTFIX } from '../../config/consts';

// Returns target use value which is used inside the app
// export function getInternalTargetUse(targetUse) {
//     return targetUse === DATA_CENTER_FLOW_POSTFIX_URL ? DATA_CENTER_FLOW_POSTFIX : targetUse;
// }
//
// // Data center target use value in URL must be data_center, see comments in APCG-5457
// export function getTargetUseForURL(targetUse) {
//     return targetUse === DATA_CENTER_FLOW_POSTFIX ? DATA_CENTER_FLOW_POSTFIX_URL : targetUse;
// }

/**
 * This HOC substitutes targetUse value from data_center ( in url ) to
 * dataCenter (inside the app).
 * dataCenter is changed in URL becase of the comment in APCG-5457
 */

function normalizeTargetUse(props) {
    // const targetUse = get(props, 'match.params.targetUse');
    // if (targetUse) {
    //     set(props, 'match.params.targetUse', getInternalTargetUse(targetUse));
    // }
    return props;
}

export default compose(
    withRouter,
    mapProps(props => normalizeTargetUse(props)),
);
